// import React, { useState } from "react";
// import { FiUploadCloud } from "react-icons/fi";
// import theme from "../components/shared/theme";

// const UserAddBulk = () => {
//   const [csvFile, setCsvFile] = useState(null);
//   const [previewFileName, setPreviewFileName] = useState("");

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setCsvFile(file);
//     setPreviewFileName(file?.name || "");
//   };

//   const handleUpload = () => {
//     if (!csvFile) {
//       alert("Please select a CSV file.");
//       return;
//     }

//     // TODO: Upload logic goes here
//     console.log("Uploading:", csvFile);
//   };

//   return (
//     <div
//       style={{
//         backgroundColor: theme.colors.background,
//         minHeight: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         padding: theme.spacing.lg,
//       }}
//     >
//       <div
//         style={{
//           backgroundColor: "#fff",
//           padding: theme.spacing.xl,
//           borderRadius: theme.radius.lg,
//           boxShadow: theme.shadow.md,
//           maxWidth: 500,
//           width: "100%",
//           textAlign: "center",
//         }}
//       >
//         <h2
//           style={{
//             fontSize: theme.font.size["2xl"],
//             fontWeight: theme.font.weight.bold,
//             marginBottom: theme.spacing.md,
//             color: theme.colors.primary,
//           }}
//         >
//           Upload CSV File
//         </h2>

//         <label
//           htmlFor="csv-upload"
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             border: `2px dashed ${theme.colors.gray}`,
//             borderRadius: theme.radius.md,
//             padding: theme.spacing.lg,
//             cursor: "pointer",
//             backgroundColor: "#f9f9f9",
//           }}
//         >
//           <FiUploadCloud size={48} color={theme.colors.grayDark} />
//           <p style={{ marginTop: theme.spacing.sm, color: theme.colors.grayDark }}>
//             Click to choose CSV file
//           </p>
//           <input
//             id="csv-upload"
//             type="file"
//             accept=".csv"
//             style={{ display: "none" }}
//             onChange={handleFileChange}
//           />
//         </label>

//         {previewFileName && (
//           <p style={{ marginTop: theme.spacing.sm, fontSize: theme.font.size.base, color: theme.colors.grayDark }}>
//             Selected: <strong>{previewFileName}</strong>
//           </p>
//         )}

//         <button
//           onClick={handleUpload}
//           style={{
//             marginTop: theme.spacing.md,
//             padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
//             backgroundColor: theme.colors.primary,
//             color: "white",
//             border: "none",
//             borderRadius: theme.radius.md,
//             fontSize: theme.font.size.base,
//             cursor: "pointer",
//           }}
//         >
//           Upload
//         </button>
//       </div>
//     </div>
//   );
// };

// export default UserAddBulk;



import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiUploadCloud } from "react-icons/fi";
import { uploadUserBulk } from "../redux/actions/userBulkUploadActions";
import theme from "../components/shared/theme";
import { ClipLoader } from "react-spinners";

const UserAddBulk = () => {
  const dispatch = useDispatch();
  const { loading, response } = useSelector((state) => state.userBulkUpload);

  const [csvFile, setCsvFile] = useState(null);
  const [previewFileName, setPreviewFileName] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setCsvFile(file);
    setPreviewFileName(file?.name || "");
  };

  const handleUpload = () => {
    if (!csvFile) {
      alert("Please select a CSV file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", csvFile);
    dispatch(uploadUserBulk(formData));
  };

  const summary = response?.data;

  return (
    <div
      style={{
        backgroundColor: theme.colors.background,
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: theme.spacing.lg,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: theme.spacing.xl,
          borderRadius: theme.radius.lg,
          boxShadow: theme.shadow.md,
          maxWidth: 600,
          width: "100%",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: theme.font.size["2xl"],
            fontWeight: theme.font.weight.bold,
            marginBottom: theme.spacing.md,
            color: theme.colors.primary,
          }}
        >
          Bulk Upload Users
        </h2>

        <label
          htmlFor="csv-upload"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: `2px dashed ${theme.colors.gray}`,
            borderRadius: theme.radius.md,
            padding: theme.spacing.lg,
            cursor: "pointer",
            backgroundColor: "#f9f9f9",
          }}
        >
          <FiUploadCloud size={48} color={theme.colors.grayDark} />
          <p style={{ marginTop: theme.spacing.sm, color: theme.colors.grayDark }}>
            Click to choose CSV file
          </p>
          <input
            id="csv-upload"
            type="file"
            accept=".csv, .xlsx, .xls"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </label>

        {previewFileName && (
          <p style={{ marginTop: theme.spacing.sm, fontSize: theme.font.size.base, color: theme.colors.grayDark }}>
            Selected: <strong>{previewFileName}</strong>
          </p>
        )}

        <button
          onClick={handleUpload}
          disabled={loading}
          style={{
            marginTop: theme.spacing.md,
            padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
            backgroundColor: theme.colors.primary,
            color: "white",
            border: "none",
            borderRadius: theme.radius.md,
            fontSize: theme.font.size.base,
            cursor: loading ? "not-allowed" : "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          {loading ? <ClipLoader size={18} color="#fff" /> : "Upload"}
        </button>

        {/* Upload summary display */}
        {summary && (
          <div
            style={{
              marginTop: theme.spacing.lg,
              textAlign: "left",
              backgroundColor: "#f7f7f7",
              borderRadius: theme.radius.md,
              padding: theme.spacing.md,
              fontSize: theme.font.size.base,
            }}
          >
            <h4 style={{ fontWeight: theme.font.weight.semibold, marginBottom: theme.spacing.sm }}>
              Upload Summary
            </h4>
            <p><strong>Total Records:</strong> {summary.total_records}</p>
            <p><strong>Inserted Records:</strong> {summary.inserted_records}</p>
            <p><strong>Skipped Records:</strong> {summary.skipped_records}</p>

            {summary.skipped_phones?.length > 0 && (
              <div style={{ marginTop: theme.spacing.sm }}>
                <p><strong>Skipped Reasons:</strong></p>
                <ul style={{ maxHeight: "150px", overflowY: "auto", paddingLeft: "20px", color: "#b00020" }}>
                  {summary.skipped_phones.slice(0, 50).map((msg, i) => (
                    <li key={i}>{msg}</li>
                  ))}
                  {summary.skipped_phones.length > 50 && (
                    <li>...and {summary.skipped_phones.length - 50} more</li>
                  )}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserAddBulk;
